import styled, { css, keyframes } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'
import { BtnBorder } from '../../../../components/Form/Button/style'

export const ExchangeItemStyle = styled.div`
	display: flex;
	flex-flow: row wrap;
	position: relative;
	@media (${device.tabletS}) {
		margin-bottom: ${rem(30)};
	}
`
export const Body = styled.div`
	flex: 1 0;
	max-width: calc(100% - ${rem(284)});
	padding-left: ${rem(34)};
	@media (${device.tabletS}) {
		flex: 0 0 100%;
		max-width: 100%;
		padding-left: 0;
	}
`
export const Preview = styled.div`
	position: relative;
	padding: ${rem(0, 5)};
	.bigImg {
		max-width: ${rem(530)};
		height: auto;
		max-height: 70vh;
	}
`
export const Title = styled.h2`
	font-weight: 600;
	font-size: ${rem(26)};
	line-height: ${rem(35)};
	margin-bottom: ${rem(8)};
	position: relative;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
		`}

	@media (${device.mobileXL}) {
		font-size: ${rem(20)};
		line-height: ${rem(27)};
		margin-bottom: ${rem(10)};
	}
`
export const Price = styled.div`
	font-weight: 700;
	font-size: ${rem(26)};
	line-height: ${rem(35)};
	letter-spacing: ${rem(0.4)};
	margin-bottom: ${rem(8)};
	margin-left: auto;
	position: relative;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.mobileXL}) {
		font-size: ${rem(20)};
		line-height: ${rem(27)};
		margin-bottom: ${rem(10)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-weight: normal;
				font-size: ${rem(15)};
				line-height: ${rem(20)};
				letter-spacing: ${rem(0.06)};
			`}
	}
`
export const ButtonGroup = styled.div`
	margin: 0 -8px;

	& > div {
		padding: 0 8px;
	}
`
export const Description = styled.div`
	width: 100%;
	position: relative;
	overflow: hidden;
	max-height: 0;
	transition: max-height 0.3s;
	${(p) =>
		p.isOpen &&
		css`
			max-height: 100vh;
		`}
`
export const Editor = styled.div`
	position: relative;
	padding: ${rem(20, 0)};
`
export const ButtonDescription = styled(BtnBorder)`
	justify-content: space-between;

	&:hover {
		background-color: transparent;
		color: ${({ theme }) => theme.color.blackOne};

		svg {
			fill: ${({ theme }) => theme.color.blackOne};
		}
	}

	.icon {
		&-left {
			left: ${rem(20)};
		}

		&-right {
			right: ${rem(20)};
		}
	}

	${(p) =>
		p.isOpen &&
		css`
			svg {
				margin-top: ${rem(8)};
			}
		`}
`
export const SwiperSlider = styled.div`
	flex: 0 0 ${rem(284)};
	max-width: ${rem(284)};
	@media (${device.tabletS}) {
		flex: 0 0 100%;
		max-width: 100%;
	}
	@media (${device.mobileXL}) {
		margin-bottom: ${rem(16)};
	}

	img {
		display: block;
		width: 100%;
		height: ${rem(284)};
		object-fit: cover;
		border-radius: ${rem(2)};
		@media (${device.mobileXL}) {
			height: auto;
		}
	}

	.swiper-container {
		@media (${device.mobileXL}) {
			padding: ${rem(0, 15)};
		}
	}

	.swiper-button-next,
	.swiper-button-prev {
		top: ${rem(145)};
		width: ${rem(40)};
		height: ${rem(40)};
		margin-top: ${rem(-20)};
		color: ${({ theme }) => theme.color.blackOne};
		background-color: rgba(255, 255, 255, 0.4);
		border-radius: 50%;
		transition: background-color 0.3s;
		display: flex;

		&::after {
			font-size: ${rem(20)};
			@media (${device.mobileXL}) {
				font-size: 0;
				border-top: ${rem(8)} solid transparent;
				border-bottom: ${rem(8)} solid transparent;
			}
		}

		&:hover {
			background-color: rgba(255, 255, 255, 0.9);
		}
	}

	.swiper-button-next::after {
		@media (${device.mobileXL}) {
			border-left: ${rem(8)} solid ${({ theme }) => theme.color.blackOne};
		}
	}

	.swiper-button-prev::after {
		@media (${device.mobileXL}) {
			border-right: ${rem(8)} solid ${({ theme }) => theme.color.blackOne};
		}
	}

	.swiper-button-next {
		padding-left: ${rem(3)};
	}

	.swiper-button-prev {
		padding-right: ${rem(3)};
	}

	.swiper-pagination {
		position: relative;
		display: flex;
		padding: ${rem(4, 0)};
		margin: ${rem(0, -2)};
		bottom: 0;
		width: auto;
		@media (${device.mobileXL}) {
			display: none;
		}
	}

	.swiper-pagination-bullet {
		flex: 0 0 33.3333%;
		max-width: 33.3333%;
		height: auto;
		margin: 0 !important;
		padding: ${rem(0, 2)};
		border-radius: 0;
		background-color: transparent;
		opacity: 1;

		&-active {
			display: none;
		}

		img {
			height: ${rem(92)};
		}
	}
`

/* Animations */
const addToCartFrame = keyframes`
	0% {
       transform: scale(0.999, 0.999) translate3d(0px, 0px, 1px);
       animation-timing-function:ease-in-out
   }

   50% {
       transform: scale(0.999, 0.999) translate3d(0px, 12px, 1px);
       animation-timing-function:ease-in-out
   }

   100% {
       transform: scale(0.999, 0.999) translate3d(0px, 0px, 1px);
       animation-timing-function:ease-in-out
   }
`

const runAnimationPosition = keyframes`
	0% {
		left: 0;
	}
	100% {
		left: 50%;
		transform: translateY(calc(1000px - 50%))
	}
`

export const ExchangeAddItem = styled.div`
	position: absolute;
	visibility: hidden;
	top: 0;
	left: 0;
	z-index: 9;
	width: ${rem(70)};

	> img {
		display: block;
		width: 100%;
		height: auto;
	}

	&.visible {
		visibility: visible;
	}

	&.startMotion {
		animation: ${addToCartFrame} 0.9s forwards;
	}

	&.runMotionPosition {
		animation: ${runAnimationPosition} 1s ease forwards;
	}
`

export const SwiperSliderForPopup = styled(SwiperSlider)`
	max-width: none;
	width: 100%;
	.swiper-button-next,
	.swiper-button-prev {
		top: ${rem(250)};
		color: ${({ theme }) => theme.color.blackOne};
		background-color: ${({ theme }) => theme.color.grayFive};
		@media (${device.laptopS}) {
			top: ${rem(170)};
		}
	}

	.swiper-pagination {
		display: flex;
		justify-content: center;
	}

	.swiper-pagination-bullet {
		height: ${rem(20)};
		max-width: ${rem(20)};
		border-radius: ${rem(20)};
		border: 3px solid rgba(255, 255, 255, 1);
		background-color: ${({ theme }) => theme.color.grayFive};
		&-active {
			display: inline-block;
			background-color: ${({ theme }) => theme.color.blackOne};
		}
	}
`
